import React from "react";
import URLtoWORD from "./pages/MainPage/index";
import "./App.css";

const App: React.FC = () => {
  return <URLtoWORD />;
};

export default App;
